import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import type { RegisterEmailDto, RegisterPhoneDto, RegisterResponseDto } from '../api/auth.repository';
import { AuthService } from '../model/auth.service';
export type AuthError = {
  message: string;
  code?: string;
  status?: number;
};
export type RegisterResult = {
  success: true;
  data: RegisterResponseDto;
} | {
  success: false;
  error: string;
};
export const useRegister = () => {
  const $ = _c(20);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const registerEmailMutation = useMutation(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mutationFn: _temp2
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const registerPhoneMutation = useMutation(t1);
  let t2;
  if ($[2] !== registerEmailMutation) {
    t2 = async data_1 => {
      ;
      try {
        const responseData = await registerEmailMutation.mutateAsync(data_1);
        return {
          success: true,
          data: responseData
        };
      } catch (t3) {
        const err_1 = t3;
        const error_1 = err_1 as {
          message?: string;
        };
        return {
          success: false,
          error: error_1?.message || "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438"
        };
      }
    };
    $[2] = registerEmailMutation;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const registerEmail = t2;
  let t3;
  if ($[4] !== registerPhoneMutation) {
    t3 = async data_2 => {
      ;
      try {
        const responseData_0 = await registerPhoneMutation.mutateAsync(data_2);
        return {
          success: true,
          data: responseData_0
        };
      } catch (t4) {
        const err_2 = t4;
        const error_2 = err_2 as {
          message?: string;
        };
        return {
          success: false,
          error: error_2?.message || "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438"
        };
      }
    };
    $[4] = registerPhoneMutation;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const registerPhone = t3;
  const t4 = registerEmailMutation.isPending || registerPhoneMutation.isPending;
  const t5 = registerEmailMutation.isSuccess || registerPhoneMutation.isSuccess;
  const t6 = registerEmailMutation.isError || registerPhoneMutation.isError;
  const t7 = registerEmailMutation.error || registerPhoneMutation.error;
  const t8 = registerEmailMutation.data || registerPhoneMutation.data;
  let t9;
  if ($[6] !== registerEmailMutation || $[7] !== registerPhoneMutation) {
    t9 = () => {
      registerEmailMutation.reset();
      registerPhoneMutation.reset();
    };
    $[6] = registerEmailMutation;
    $[7] = registerPhoneMutation;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== registerEmail || $[10] !== registerEmailMutation || $[11] !== registerPhone || $[12] !== registerPhoneMutation || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = {
      registerEmail,
      registerPhone,
      registerEmailMutation,
      registerPhoneMutation,
      isLoading: t4,
      isEmailRegistering: registerEmailMutation.isPending,
      isPhoneRegistering: registerPhoneMutation.isPending,
      isSuccess: t5,
      isError: t6,
      error: t7,
      data: t8,
      reset: t9
    };
    $[9] = registerEmail;
    $[10] = registerEmailMutation;
    $[11] = registerPhone;
    $[12] = registerPhoneMutation;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
async function _temp(data) {
  ;
  try {
    const response = await AuthService.registerEmail(data);
    return response;
  } catch (t0) {
    const err = t0;
    const error = err as {
      response?: {
        data?: {
          message?: string;
          code?: string;
        };
        status?: number;
      };
      message?: string;
      code?: string;
      status?: number;
    };
    const errorMessage = error?.response?.data?.message || error?.message || "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438";
    throw {
      message: errorMessage,
      code: error?.response?.data?.code || error?.code,
      status: error?.response?.status || error?.status
    } as AuthError;
  }
}
async function _temp2(data_0) {
  ;
  try {
    const response_0 = await AuthService.registerPhone(data_0);
    return response_0;
  } catch (t0) {
    const err_0 = t0;
    const error_0 = err_0 as {
      response?: {
        data?: {
          message?: string;
          code?: string;
        };
        status?: number;
      };
      message?: string;
      code?: string;
      status?: number;
    };
    const errorMessage_0 = error_0?.response?.data?.message || error_0?.message || "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438";
    throw {
      message: errorMessage_0,
      code: error_0?.response?.data?.code || error_0?.code,
      status: error_0?.response?.status || error_0?.status
    } as AuthError;
  }
}